module.exports = __webpack_public_path__ + "static/Shojumaru-b79f920183ec1e232700b991c8ed3149.ttf";